import React, { useState } from 'react';
import { useRestaurantCart, RestaurantCheckout } from '@happyspace/sdk/restaurant';
import { ShoppingBag, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function CheckoutPage() {
  const { items, updateQuantity, removeItem } = useRestaurantCart();
  const [checkoutOpen, setCheckoutOpen] = useState(true);
  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);

  if (items.length === 0) {
    return (
      <div className="pt-20 min-h-screen bg-[#F9F6F0] flex items-center justify-center">
        <div className="text-center">
          <ShoppingBag className="w-16 h-16 text-gray-300 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-gray-700 mb-2">Your cart is empty</h2>
          <p className="text-gray-500 mb-8">Add some delicious dishes to get started!</p>
          <Link to="/menu" className="bg-[#0054e9] text-white px-8 py-3 rounded-full font-bold hover:bg-[#015796] transition-colors">
            Browse Menu
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-20 min-h-screen bg-[#F9F6F0]">
      <div className="max-w-3xl mx-auto px-4 py-12">
        <Link to="/menu" className="inline-flex items-center gap-2 text-gray-500 hover:text-gray-900 mb-8 font-semibold transition-colors group">
          <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" /> Back to Menu
        </Link>

        <h1 className="text-3xl font-bold text-gray-900 mb-8">Your Order</h1>

        <div className="bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden mb-6">
          {items.map(item => (
            <div key={item.id} className="flex items-center gap-4 p-6 border-b border-gray-50 last:border-b-0">
              {item.image ? (
                <img src={item.image} alt={item.name} className="w-16 h-16 rounded-2xl object-cover" />
              ) : (
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-50 to-yellow-50 flex items-center justify-center text-2xl">🍛</div>
              )}
              <div className="flex-1">
                <h3 className="font-bold text-gray-900">{item.name}</h3>
                <p className="text-[#0054e9] font-semibold">${(item.price * item.quantity).toFixed(2)}</p>
              </div>
              <div className="flex items-center gap-3">
                <button onClick={() => updateQuantity(item.id, item.quantity - 1)} className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-600 hover:bg-gray-200 font-bold">
                  −
                </button>
                <span className="w-6 text-center font-bold">{item.quantity}</span>
                <button onClick={() => updateQuantity(item.id, item.quantity + 1)} className="w-8 h-8 rounded-full bg-[#0054e9] text-white flex items-center justify-center hover:bg-[#015796] font-bold">
                  +
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-6 mb-6">
          <div className="flex justify-between text-lg font-bold text-gray-900">
            <span>Total</span>
            <span>${total.toFixed(2)}</span>
          </div>
        </div>

        <button
          onClick={() => setCheckoutOpen(true)}
          className="w-full bg-[#0054e9] text-white py-4 rounded-full font-bold text-lg hover:bg-[#015796] transition-colors shadow-lg shadow-blue-500/25"
        >
          Proceed to Checkout
        </button>
      </div>

      <RestaurantCheckout
        open={checkoutOpen}
        onClose={() => setCheckoutOpen(false)}
      />
    </div>
  );
}
